import { baseUrl } from '@/api/types';

export function expenseIndexUrl() {
  return `${baseUrl}/expenses`;
}

export function expenseFileFormUrl() {
  return `${expenseIndexUrl()}/files`;
}

export function expenseCreateUrl() {
  return `${expenseIndexUrl()}/create`;
}

export function expenseEditUrl(expenseId) {
  return `${expenseIndexUrl()}/${expenseId}/edit`;
}

export function expenseDetailsUrl(expenseId) {
  return `${expenseIndexUrl()}/${expenseId}/details`;
}

export function expenseStoreUrl() {
  return expenseIndexUrl();
}

export function expenseUpdateUrl(expenseId) {
  return `${expenseIndexUrl()}/${expenseId}`;
}

export function expenseDeleteUrl(expenseId) {
  return `${expenseIndexUrl()}/${expenseId}`;
}

export function expenseRequisitesIndexUrl() {
  return `${baseUrl}/expense-requisites`;
}

export function expenseRequisitesUpdateUrl(expenseId) {
  return `${expenseRequisitesIndexUrl()}/${expenseId}`;
}

export function expenseExportIndexUrl() {
  return `${baseUrl}/expense-export`;
}

export function expenseExportCreateUrl() {
  return `${expenseExportIndexUrl()}/create`;
}

export function expenseExportStoreUrl() {
  return `${expenseExportIndexUrl()}`;
}

export function expenseRestoreUrl(invoiceId) {
  return `${baseUrl}/expense-restore/${invoiceId}`;
}

// Expense payment modal urls
export function expensePaymentIndexUrl(expenseId) {
  return `${baseUrl}/expense-payments/${expenseId}`;
}

export function expensePaymentModalCreateUrl(expenseId) {
  return `${baseUrl}/expense-payments/${expenseId}/create`;
}

export function expensePaymentModalEditUrl(paymentId) {
  return `${baseUrl}/expense-payments/${paymentId}/edit`;
}

export function expensePaymentModalStoreUrl(expenseId) {
  return `${baseUrl}/expense-payments/${expenseId}`;
}

export function expensePaymentModalUpdateUrl(paymentId) {
  return `${baseUrl}/expense-payments/${paymentId}/update`;
}

export function expensePaymentDeleteUrl(expenseId) {
  return `${baseUrl}/expense-payments/${expenseId}`;
}

export function expensePaymentCheckUrl(invoiceId) {
  return `${baseUrl}/expense-payment-check/${invoiceId}`;
}

export function expensePaymentValidateUrl() {
  return `${baseUrl}/expense-payment-validation`;
}

// expense pdf urls
export function expensePdfPrintUrl(expenseId, language) {
  return `${baseUrl}/expenses/${expenseId}/pdf/print/${language}`;
}

export function expenseDownloadUrl(expenseId, language, format = 'pdf') {
  return `${baseUrl}/expenses/${expenseId}/${format}/download/${language}`;
}

// fixed assets urls
export function fixedAssetValidationUrl() {
  return `${baseUrl}/fixed-asset-validation`;
}

export function fixedAssetIndexUrl() {
  return `${baseUrl}/fixed-assets`;
}

export function fixedAssetDetailsUrl(fixedAssetId) {
  return `${fixedAssetIndexUrl()}/${fixedAssetId}/details`;
}

export function expenseMassActionUrl() {
  return `${expenseIndexUrl()}/mass-actions`;
}

export function expenseMassActionExportUrl() {
  return `${expenseIndexUrl()}/mass-actions/export`;
}
